<template>
    <div>
        <footer class="site-footer custom-border-top bg-light-green py-4">
        <div class="container">
            <div class="row text-center mb-3">
                <div class="col-12">
                    <router-link to="/about" class="mx-2 footer-link">{{ $t('footer.about') }}</router-link>
                    <span class="mx-2 text-secondary">|</span>
                    <router-link to="/how-cashback-works" class="mx-2 footer-link">How Cash Back Works</router-link>
                    <span class="mx-2 text-secondary">|</span>
                    <router-link to="/cashback-guide" class="mx-2 footer-link">Cash Back Guide</router-link>
                    <span class="mx-2 text-secondary">|</span>
                    <router-link to="/faq" class="mx-2 footer-link">FAQ</router-link>
                    <span class="mx-2 text-secondary">|</span>
                    <router-link to="/terms" class="mx-2 footer-link">{{ $t('footer.terms') }}</router-link>
                    <span class="mx-2 text-secondary">|</span>
                    <router-link to="/privacy" class="mx-2 footer-link">{{ $t('footer.privacy') }}</router-link>
                </div>
            </div>
            <div class="row text-center">
                <div class="col-12">
                <p class="footer-disclosure mx-auto mb-2">CashBoomerang may earn commissions from disclosed affiliate links. Only offers explicitly marked Cash Back Eligible can earn a user reward. Amazon links are not cash-back eligible.</p>
                <p class="m-0 footer-text">
                &copy; {{ currentYear }} CashBoomerang. All rights reserved.
                </p>
                </div>
            </div>
        </div>
        </footer>
    </div>
</template>

<script>
export default {
  name: 'SiteFooter',
  computed: {
    currentYear() { return new Date().getFullYear() }
  }
}
</script>

<style lang="scss" scoped>
.footer-link {
    color: #555;
    text-decoration: none;
    font-weight: 500;
    transition: color 0.3s;
    
    &:hover {
        color: #000;
        text-decoration: underline;
    }
}

.footer-text {
    color: #555;
    font-size: 0.9rem;
}
.footer-disclosure { max-width: 760px; color: #657168; font-size: .8rem; line-height: 1.5; }

// Support for Dark Mode (global class on body)
// Since this is scoped, we might need to rely on the global style.scss overriding checks 
// OR we assuming global dark-mode styles for links might not catch this specific class.
// But mostly, getting specific here is safer for the base state (Light Green bg).
</style>
